export enum Text {
  FAQ = 'FAQ',
  TALK_TO_SPECIALIST = 'Talk to specialist',
  YOUR_PLAN = 'YOUR PLAN',
  OK_GOT_IT = 'Ok Got It',
  COMERCIAL_TEAM_CONTACT = 'Our commercial team will contact the account administrator within 1 business day',
  WE_RECEIVED_YOUR_REQUEST = 'We received your request',
  REDIRECTED_TO_WHATSAPP = 'You have been redirected to Whatsapp',
  SEND_US_YOUR_QUESTION = 'Send us your question and we will get back to you soon.',
  PLANS_AVAILABILITY = 'Availability of plan benefits depends on company profile, make sure your company is contemplated',
  IDEAL_PLAN_HERE = 'The ideal plan for your company is here. Talk to our experts to learn more',
  SIMPLIFY_YOUR_OPERATION = 'Simplify your logistics operations',
  WRONG = 'Something went wrong',
  CLICK_HERE = 'Click here',
  TO_RECHARGE = 'To recharge',
  ON_THE_PAGE = 'You are on the page',
  INVOICE_DETAILS = 'Check your invoice details',
  INVOICE = 'Invoice',
  OF = 'Of',
  NO_DATA_TO_DISPLAY = 'The is no data to display',
  HOW_WE_CAN_HELP = 'How we can help?',
  SUBMIT = 'Submit',
  DESCRIBE_YOUR_QUESTION = 'Describe your question',
  BRIEFLY_DESCRIBE = 'Briefly describe how we can help.',
  GENERIC_ERROR = 'An error has occurred in the request. Please try again later.',
}
